import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ClaryNextInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ClaryNextInfoModal: React.FC<ClaryNextInfoModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl">
            {t("about_clarynext") || "About ClaryNext"}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <Info className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
            <div className="space-y-4">
              <p className="text-gray-700 leading-relaxed">
                {t("clarynext_intro") ||
                  "ClaryNext is a platform that helps people improve their thinking and behavior through structured, step-by-step activities. It allows you to reflect on real situations, redesign unhelpful patterns, and build new habits with clarity and purpose."}
              </p>

              <div>
                <h3 className="font-semibold text-gray-900 mb-2">
                  {t("how_it_works") || "How It Works"}
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start gap-2">
                    <span className="text-primary mt-1">•</span>
                    <span>
                      {t("how_it_works_1") ||
                        "Follow structured activities designed by experts"}
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary mt-1">•</span>
                    <span>
                      {t("how_it_works_2") ||
                        "Reflect on your thoughts and behaviors in a guided way"}
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary mt-1">•</span>
                    <span>
                      {t("how_it_works_3") ||
                        "Track your progress and build better habits over time"}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ClaryNextInfoModal;
